import React, { useState } from 'react';

// Input de contraseña con botón "ojo" para mostrar/ocultar el valor.
// Pensado para reusarse en Login (className) y modales con styles inline.
//
// Pasa cualquier prop de <input> (value, onChange, placeholder, autoFocus,
// required, etc.). `inputClassName` y `inputStyle` se aplican al input
// interno; el wrapper relativo es transparente para el layout existente.
export default function PasswordField({
  inputClassName,
  inputStyle,
  ...inputProps
}) {
  const [visible, setVisible] = useState(false);
  const baseStyle = { width: '100%', boxSizing: 'border-box', ...(inputStyle || {}), paddingRight: 38 };

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <input
        {...inputProps}
        type={visible ? 'text' : 'password'}
        className={inputClassName}
        style={baseStyle}
      />
      <button
        type="button"
        onClick={() => setVisible(v => !v)}
        aria-label={visible ? 'Ocultar contraseña' : 'Mostrar contraseña'}
        title={visible ? 'Ocultar' : 'Mostrar'}
        tabIndex={-1}
        style={{
          position: 'absolute',
          right: 6,
          top: '50%',
          transform: 'translateY(-50%)',
          width: 28,
          height: 28,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          color: 'var(--ink-400, #888)',
          padding: 0,
          fontFamily: 'inherit',
        }}
      >
        {visible ? (
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a21 21 0 0 1 5.06-5.94"/>
            <path d="M9.9 4.24A10.94 10.94 0 0 1 12 4c7 0 11 8 11 8a21 21 0 0 1-3.17 4.19"/>
            <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24"/>
            <line x1="1" y1="1" x2="23" y2="23"/>
          </svg>
        ) : (
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8S1 12 1 12z"/>
            <circle cx="12" cy="12" r="3"/>
          </svg>
        )}
      </button>
    </div>
  );
}
